<template>
 <section>
  <Header class="header" @showAside="showAside" />
  <Avatar picture="/lib/avatar.jpg" :title="avatarTitle" class="avatar" />
  <Aside class="aside" :showAside="aside" @showAside="showAside" />
  <router-view class="main" @updateAvatarTitle="updateAvatarTitle" />
 </section>
</template>
<script>
import Header from '@/components/Header.vue';
import Avatar from '@/components/Avatar.vue';
import Aside from '@/components/Aside.vue';
export default {
 components: {Header, Avatar, Aside},
 data(){
  return {
   aside:false,
   avatarTitle:""
  };
 },
 methods:{
  showAside(v){ this.aside=v; },
  updateAvatarTitle(v){ this.avatarTitle=v; }
 }
}
</script>
<style lang="scss">
@charset "utf-8";
@import url('https://fonts.googleapis.com/css?family=Give+You+Glory|Athiti');
$blue-lite-color: #2671B4;
$blue-dark-color: #1A1963;
$orange-lite-color: #FFA500;
$orange-dark-color: #A06905;
$green-lite-color: #187972;
$green-dark-color: #00514B;

.h-left{ justify-self:flex-start; }
.h-center{ justify-self:center; }
.h-right{ justify-self:flex-end; }
.v-top{ align-self:flex-start; }
.v-center{ align-self:center; }
.v-bottom{ align-self:flex-end; }
.background-fade-orange{ background-image:linear-gradient(to bottom, $orange-lite-color, $orange-dark-color) !important; }
.background-fade-blue{ background-image:linear-gradient(to bottom, $blue-lite-color, $blue-dark-color) !important; }
.background-fade-green{ background-image:linear-gradient(to bottom, $green-lite-color, $green-dark-color) !important; }
body{
 margin:0;
 padding:0;
 background-image: linear-gradient(154deg, #2671B4 0%, #1A1963 100%);
 background-size: cover;
 background-position: center top;
 background-attachment: fixed;
 background-repeat: no-repeat;
 width:100vw;
 height:100vh;
 color:#FFF;
 font-family: 'Athiti';
}
.logo{ font-family:'Give You Glory'; }
section{
 display:grid;
 grid-template-areas: "header header" "avatar main" "aside main";
 grid-template-rows: auto auto 1fr;
 grid-template-columns: 270px 1fr;
 height:100vh;
 max-width: 1100px;
 margin: 0 auto;
}
.header{ grid-area:header; }
.avatar{ grid-area:avatar; }
.aside{ grid-area:aside; height:auto; }
.main{ grid-area:main; padding:10px; }
p{
 line-height: 2.5rem;
 font-size: 1.5rem;
 text-align: justify;
 text-indent: 3rem;
}
.center-middle{
 display: flex;
 justify-content: center;
 align-items: center;
 flex-direction: column;
}
.btn{outline:0; color:#fff; text-decoration:none; font-weight:bold; text-shadow:0 -1px 0 rgba(0,0,0,0.25); background-repeat:repeat-x; border-color: rgba(0,0,0,0.1) rgba(0,0,0,0.1) rgba(0,0,0,0.25); display:inline-block; padding:4px 12px; margin-bottom:0; font-size:1em; line-height:1.5em; text-align:center; vertical-align:middle; cursor:pointer; border:1px solid #bbb; -webkit-border-radius:4px; -webkit-box-shadow:inset 0 1px 0 rgba(255,255,255,0.2),0 1px 2px rgba(0,0,0,0.05); box-shadow:inset 0 1px 0 rgba(255,255,255,0.2),0 1px 2px rgba(0,0,0,0.05);}
.btn:hover{color:#fff; text-decoration:none; text-decoration:none; background-position:0 -15px; -webkit-transition:background-position 0.1s linear; transition:background-position 0.1s linear;}
.btnblu{background-image:-webkit-linear-gradient(top,#08c,#04c); background-image:linear-gradient(to bottom, #08c, #04c);}
.btnblu:hover{background-color:#04c;}
//mobile
@media screen and (max-width:750px){
 section{ grid-template-areas:"header header" "avatar avatar" "main main"; }
 p{ font-size:1rem; line-height: 1.5rem; }
 .aside{ display:none; }
}
</style>